module.exports = __webpack_public_path__ + "img/note-empty.9c8396ee.png";